import Vue from "vue";
import VueRouter from "vue-router";
const Home = () => import("../views/Home");
const Activities = () => import("../views/Activities");
const Detail = () => import("../views/Detail");
const Preview = () => import("../views/Preview");
const Details = () => import("../views/DetailTest");
const Content = () => import("../views/Content.vue");
const HomeTest = () => import("../views/HomeTest");
Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "主页",
    redirect: "/home",
  },
  {
    path: "/home",
    name: "home",
    component: Home,
  },
  {
    path: "/content",
    name: "Content",
    component: Content,
  },
  {
    path: "/detail",
    name: "detail",
    component: Detail,
  },
  // 首页Activities跳转页面
  {
    path: "/activities",
    name: "Activities",
    component: Activities,
  },
  // 预览页面
  {
    path: "/preview",
    name: "preview",
    component: Preview,
  },

  {
    path: "/details",
    name: "details",
    component: Details,
  },
  {
    path: "/home1",
    name: "home1",
    component: HomeTest,
  },
];

const router = new VueRouter({
  // mode: 'history', 开启后路由里就去掉#
  // scrollBehavior: () => ({ y: 0 }),
  base: process.env.BASE_URL,
  routes,
});
router.beforeEach((to, from, next) => {
  document.body.scrollTop = 0; 
  document.documentElement.scrollTop = 0; 
  // window.pageYOffset = 0;
  next();
});
export default router;
